// ticket-státusz badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `ticketStatus` fogalom):
// open → info · in_progress → warning · resolved → success · closed → muted · reopened → danger, mindegyik
// vezető ikonnal. ez a fájl csak a kényelmes, névre szóló API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export interface TicketStatusBadgeProps {
  /** A nyers státusz-string (a jel forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('tickets.statusLabel.…')`-ből. */
  label: string;
  /** Rövid SÚGÓ (a státusz jelentése) — megadva a jelvény tooltipet kap (Évi #86). */
  help?: string;
  className?: string;
}

export function TicketStatusBadge({
  status,
  label,
  help,
  className,
}: TicketStatusBadgeProps): JSX.Element {
  const badge = (
    <DomainBadge kind="ticketStatus" value={status} label={label} className={className} />
  );
  if (help === undefined) return badge;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* fókuszálható, hogy billentyűzettel és érintéssel is elérhető legyen a súgó */}
        <span tabIndex={0} className="inline-flex rounded-full">
          {badge}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">{help}</TooltipContent>
    </Tooltip>
  );
}
